import http from '@/http'

const geocodeHeaders = {
	'Content-Type': 'application/json',
	Accept: 'application/json'
}

const geocode = (query, country) => {
	if (!query) return Promise.resolve([])

	return http
		.post(
			'geocode/search',
			{
				query,
				country,
				limit: 5
			},
			{ headers: geocodeHeaders }
		)
		.then(({ data }) => data || [])
}

const find = order => {
	if (!order) throw 'You need to pass "order" argument'
	if (!order) return []

	return http
		.post(
			'geocode/search',
			{
				country: order.country ? order.country.toLowerCase() : null,
				postalCode: order.postalCode || '',
				post: order.post || '',
				city: order.city || '',
				street: order.street || '',
				state: order.state || '',
				limit: 5
			},
			{ headers: geocodeHeaders }
		)
		.then(({ data }) => data || [])
}

export default {
	find,
	geocode
}
